define(function (require) {
    var $ = require('jquery');
    $(function () {
        var favIcon = document.querySelector("link[rel='shortcut icon']");
        if (window.matchMedia &&
            window.matchMedia('(prefers-color-scheme: dark)').matches) {
            favIcon.href = "/Areas/Partenaire/GeneraliLux/Static/images/Fav-icon-dark.png";
        }
    });
});
//# sourceMappingURL=SharedNvision.js.map